/**
 * Format date to readable format
 */
export const formatDate = (dateString: string) =>
  new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

/**
 * Get badge color for sample tag type
 */
export const getTypeColor = (type: string) => {
  switch (type) {
    case 'Fit':
      return 'yellow';
    case 'Proto Development':
      return 'red';
    case 'Pre-Production':
      return 'purple';
    case 'TOP':
      return 'green';
    case 'First Sample':
      return 'primary';
    default:
      return 'neutral';
  }
};

/**
 * Get display text for sample tag type
 */
export const getTypeDisplayText = (type: string) => {
  switch (type) {
    case 'Proto Development':
      return 'Proto';
    case 'Pre-Production':
      return 'PP';
    case 'First Sample':
      return 'First';
    case 'Fit':
      return 'Fit';
    case 'TOP':
      return 'TOP';
    default:
      return type;
  }
};
